// extracted by mini-css-extract-plugin
module.exports = {"largeBody":"LargeBody_largeBody__EW27W"};